var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-loader",style:(_vm.cssProps)},[_c('span',{staticClass:"loader-part"}),_c('span',{staticClass:"loader-part"}),_c('span',{staticClass:"loader-part"}),_c('span',{staticClass:"loader-part"})])}
var staticRenderFns = []

export { render, staticRenderFns }